import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNextArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.98242 0L7.57242 1.41L13.1524 7H0.982422V9H13.1524L7.57242 14.59L8.98242 16L16.9824 8L8.98242 0Z",
		fill: "#0F7B85"
	})
});
export default SvgNextArrow;
